export const DEFAULT_AVATAR = "/img/user_avatar.jpg";

export const avatars = [
  "/img/avatar/avatarF001.webp",
  "/img/avatar/avatarF002.webp",
  "/img/avatar/avatarF003.webp",
  "/img/avatar/avatarF004.webp",
  "/img/avatar/avatarF005.webp",
  "/img/avatar/avatarF006.webp",
  "/img/avatar/avatarF007.webp",
  "/img/avatar/avatarF008.webp",
  "/img/avatar/avatarM001.webp",
  "/img/avatar/avatarM002.webp",
  "/img/avatar/avatarM003.webp",
  "/img/avatar/avatarM004.webp",
  "/img/avatar/avatarM005.webp",
  "/img/avatar/avatarM006.webp",
  "/img/avatar/avatarM007.webp",
  "/img/avatar/avatarM008.webp",
  "/img/avatar/avatarM009.webp",
];

export const EMPTY_JUDOKA = {
  nom: "",
  prenom: "",
  genre: "",
  date_naissance: "",
  poids: "",
  licence_number: "",
  licence_url: "",
  club: "",
  pays: "",
  departement: "",
  photo_url: "",
  tel_adherent: "",
  mail_adherent: "",
};

export const safeParseJson = (value) => {
  try {
    return value ? JSON.parse(value) : null;
  } catch {
    return null;
  }
};

export const getCurrentUserId = () => {
  const storedUser = safeParseJson(localStorage.getItem("userInfo"));

  return storedUser?.userId || storedUser?.id || null;
};

export const isValidHttpUrl = (value = "") => {
  try {
    const url = new URL(String(value).trim());

    return url.protocol === "http:" || url.protocol === "https:";
  } catch {
    return false;
  }
};

export const isValidEmailAddress = (value = "") => {
  const cleanValue = String(value || "").trim();

  if (!cleanValue) return true;

  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(cleanValue);
};

export const isValidPhoneNumber = (value = "") => {
  const cleanValue = String(value || "").trim();

  if (!cleanValue) return true;

  const digits = cleanValue.replace(/\D/g, "");

  return digits.length >= 6 && digits.length <= 15;
};

export const normalizePhoneForHref = (value = "") => {
  const source = String(value || "").trim();

  if (!source) return "";

  const hasLeadingPlus = source.startsWith("+");
  const digits = source.replace(/\D/g, "");

  if (!digits) return "";

  return `${hasLeadingPlus ? "+" : ""}${digits}`;
};

export const normalizeAdherentsResponse = (response) => {
  if (Array.isArray(response)) return response;
  if (Array.isArray(response?.adherents)) return response.adherents;
  if (Array.isArray(response?.Adherents)) return response.Adherents;
  if (Array.isArray(response?.data)) return response.data;
  if (Array.isArray(response?.data?.adherents)) {
    return response.data.adherents;
  }

  return [];
};

export const normalizeDateForInput = (dateValue) => {
  if (!dateValue) return "";

  const date = new Date(dateValue);

  if (!Number.isFinite(date.getTime())) return "";

  return date.toISOString().slice(0, 10);
};

export const normalizeJudokaForForm = (adherent = {}) => ({
  ...EMPTY_JUDOKA,
  ...adherent,
  date_naissance: normalizeDateForInput(adherent.date_naissance),
  poids: adherent.poids ?? "",
  licence_number: adherent.licence_number || "",
  licence_url: adherent.licence_url || "",
  club: adherent.club || "",
  pays: adherent.pays || "",
  departement: adherent.departement || "",
  photo_url: adherent.photo_url || "",
  tel_adherent: adherent.tel_adherent || "",
  mail_adherent: adherent.mail_adherent || "",
});

const nullableString = (value) => {
  const cleanValue = String(value ?? "").trim();

  return cleanValue || null;
};

export const prepareJudokaPayload = (form = {}) => {
  const numericWeight =
    form.poids === "" || form.poids === null || form.poids === undefined
      ? null
      : Number(form.poids);

  const cleanEmail = String(form.mail_adherent || "")
    .trim()
    .toLowerCase();

  return {
    nom: nullableString(form.nom),
    prenom: nullableString(form.prenom),
    genre: nullableString(form.genre),
    date_naissance: form.date_naissance || null,
    photo_url: nullableString(form.photo_url),
    poids: Number.isFinite(numericWeight) ? numericWeight : null,
    club: nullableString(form.club),
    pays: nullableString(form.pays),
    departement: nullableString(form.departement),
    licence_number: nullableString(form.licence_number),
    licence_url: nullableString(form.licence_url),
    tel_adherent: nullableString(form.tel_adherent),
    mail_adherent: cleanEmail || null,
  };
};

export const getPhotoUrl = (judoka) =>
  judoka?.photo_url || DEFAULT_AVATAR;

export const getFullName = (judoka) =>
  [judoka?.prenom, judoka?.nom].filter(Boolean).join(" ") || "Judoka";

export const formatDate = (dateString) => {
  if (!dateString) return "Non spécifiée";

  const date = new Date(dateString);

  if (!Number.isFinite(date.getTime())) return "Non spécifiée";

  return date.toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
};